import { Card } from "@heroui/react"
import { Trans } from "@lingui/react/macro"

export function FontDemo({ fontBase64 }: { fontBase64: string }) {
  const text = <Trans>The quick brown fox jumps over the lazy dog.</Trans>

  return (
    <Card css="m-6 p-10">
      <style>
        {
          /* css */ `
            @font-face {
              font-family: 'FontView';
              src: url(${JSON.stringify(fontBase64)}) format('woff2');
              font-weight: normal;
              font-style: normal;
            }`
        }
      </style>

      <div css="font-[FontView,sans-serif]">
        <p css="text-2xl">{text}</p>
        <p css="mt-1 text-xl">{text}</p>
        <p css="text-lg">{text}</p>
        <p css="mt-3 text-lg">1234567890 !@#$%^&*</p>
      </div>
    </Card>
  )
}
